import { authKey, orgKey } from "@/hooks/useAuth";
import { env } from "@/utils/env";
import type { PresignedUrlInput } from "@zora/api/concerns/cloud-storage/cloud-storage.zod";

export const presignedUrl = async (data: PresignedUrlInput) => {
  const headers = {
    "Content-Type": "application/json",
    Authorization: `Bearer ${localStorage.getItem(authKey)}`,
    "x-org-id": localStorage.getItem(orgKey) || "",
  };

  return fetch(`${env.VITE_HONO_URL}/cloud-storage/ugc/presigned-url`, {
    method: "POST",
    headers,
    body: JSON.stringify({
      organizationId: data.persist ? "2" : "1", // Default organization ID
      contentType: data.contentType,
      extension: data.extension,
    }),
  })
    .then((response) => response.json())
    .then((data) => ({
      presigned: data.presignedUrl,
    }));
};

export const uploadToPresignedUrl = async (url: string, file: File) => {
  return fetch(url, {
    method: "PUT",
    headers: {
      "Content-Type": file.type,
    },
    body: file,
  });
};
